module.exports = __webpack_public_path__ + "static/media/programmers-footer.d4dd78e8.svg";